import { GET_EMAIL } from "../components/action-types"


const getEmailAndValidateReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_EMAIL):
            return state = action.payload
        default:
            return state
    }
}

export default getEmailAndValidateReducer;